import { render, staticRenderFns } from "./SessionSummaryWindow.vue?vue&type=template&id=5d24a166&scoped=true&"
import script from "./SessionSummaryWindow.vue?vue&type=script&lang=ts&"
export * from "./SessionSummaryWindow.vue?vue&type=script&lang=ts&"
import style0 from "./SessionSummaryWindow.vue?vue&type=style&index=0&id=5d24a166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d24a166",
  null
  
)

export default component.exports